/**
 * Utility functions for handling network-related operations
 */
class NetworkUtils {
  /**
   * Handles Axios error responses and returns a user-friendly message
   * @param {Error} error The error object from Axios
   * @param setError The function to set the error state
   * @param {string} errorMessageKey Optional key to extract a specific error message from the response data
   * @returns {string} A user-friendly error message
   */
  static handleAxiosError(error, setError = undefined, errorMessageKey = undefined) {
      console.error("Axios Error:", error);
      let message;
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      const status = error.response.status;
      
      if (status === 401) {
        message = 'You are not authorized to access this resource. Please log in again.';
      } else if (status === 403) {
          message = 'You do not have permission to access this resource.';
      } else if (status === 404) {
          message = 'The requested resource was not found.';
      } else if (status === 500) {
          message = 'A server error occurred. Please try again later.';
      } else {
          message = error.response.data?.[errorMessageKey || 'Message'] ||
               error.response.data?.message || 
               `Error: ${status} - ${error.response.statusText}`;
      }
    } else if (error.request) {
      // The request was made but no response was received
        message = 'No response received from server. Please check your internet connection.';
    } else {
      // Something happened in setting up the request that triggered an Error
        message = error.message || 'An unexpected error occurred.';
    }

      if (setError) setError(message);
      return message;
  }
}

export default NetworkUtils;
